import React from "react";

import { Stack } from "@chakra-ui/react";

import {
  QuestionFragment,
  ReportFragment,
} from "../../../../graphql/generated/definitions";

import QuestionDocuments from "./QuestionDocuments";
import QuestionHistory from "./QuestionHistory";

const QuestionActions: React.FC<{
  question: QuestionFragment;
  report: ReportFragment;
}> = ({ question, report }) => {
  return (
    <Stack spacing={["2", "3"]} direction={["column", "row"]} mt="-1" mb="6">
      {question.documents.length > 0 && (
        <QuestionDocuments question={question} />
      )}
      {report.review.reportsCount > 1 && (
        <QuestionHistory question={question} report={report} />
      )}
    </Stack>
  );
};

export default React.memo(QuestionActions);
